/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_No_Results_FoundInputs */

const en_mobile_no_results_found = /** @type {(inputs: Mobile_No_Results_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found`)
};

const es_mobile_no_results_found = /** @type {(inputs: Mobile_No_Results_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron resultados`)
};

/**
* | output |
* | --- |
* | "No results found" |
*
* @param {Mobile_No_Results_FoundInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_no_results_found = /** @type {((inputs?: Mobile_No_Results_FoundInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_No_Results_FoundInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_no_results_found(inputs)
	return en_mobile_no_results_found(inputs)
});